<template>
    <el-row class="top">
        <el-col :span="6">
            <div class="title_logo" @click="changeData('home')">
                <el-image class="titLogo" :src="logoImg"></el-image>
                <div class="title_f">知夏中医门诊收费系统</div>
            </div>
        </el-col>
        <el-col class="top_left" :span="12">
            <el-menu :default-active="navselected"
                class="el-menu-demo"
                mode="horizontal"
                @select="handleSelect"
            >
                <el-menu-item index="home" @click="changeData('home')">
                    <el-icon><house /></el-icon>首页
                </el-menu-item>
                <el-menu-item index="todayreservation" @click="changeData('todayreservation')">
                    <el-icon><Calendar /></el-icon>今日预约
                </el-menu-item>
                <el-menu-item index="reservation" @click="changeData('reservation')">
                    <el-icon><Checked /></el-icon>预约列表
                </el-menu-item>
                <el-menu-item index="order" @click="changeData('order')">
                    <el-icon><Memo /></el-icon>门诊订单
                </el-menu-item>
                <el-menu-item index="treatorder" @click="changeData('treatorder')">
                    <el-icon><Coin /></el-icon>诊疗订单
                </el-menu-item>
                <el-sub-menu index="mall" disabled>
                    <template #title><el-icon><monitor /></el-icon>商城工作台</template>
                    <el-menu-item index="3-1">选项1</el-menu-item>
                    <el-menu-item index="3-2">选项2</el-menu-item>
                    <el-menu-item index="3-3">
                        <template #title>选项3</template>
                        <el-menu-item index="3-3-1">选项1</el-menu-item>
                        <el-menu-item index="3-3-2">选项2</el-menu-item>
                        <el-menu-item index="3-3-3">选项3</el-menu-item>
                    </el-menu-item>
                </el-sub-menu>
            </el-menu>
        </el-col>
        <el-col class="top_right" :span="6">
            <div class="top_icon mrlr10">
                <el-icon>
                    <Share/>
                </el-icon>
            </div>
            <div class="top_icon mrlr10">
                <el-icon>
                    <bell-filled/>
                </el-icon>
            </div>
            <el-dropdown>
                <el-avatar class="mrlr10" :size="36" :src="headImg"></el-avatar>
                <template #dropdown>
                    <el-dropdown-menu>
                        <el-dropdown-item @click="logout()">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </template>
            </el-dropdown>
        </el-col>
    </el-row>
</template>

<script>
import baseConfig from '@/api/config'

export default {
    data() {
        return {
            headImg: "",
            sysName: "",
            userInfo: null,
            logoImg: "",
            navselected: 'home',
        }
    },
    created() {
        // console.log(window.sessionStorage.getItem("user"));
        this.userInfo = JSON.parse(window.sessionStorage.getItem("user"));
        if (this.userInfo.avatar === null || this.userInfo.avatar === "" || this.userInfo.avatar === undefined) {
            this.headImg = baseConfig.tencentCosUrl + "/tcmmsPic/profile.jpg";
        } else {
            this.headImg = baseConfig.tencentCosUrl + this.userInfo.avatar;
        }
        this.sysName = this.userInfo.nickName;
        // console.log(this.sysName);
        this.logoImg = require("@/assets/images/logo.png");
        this.getNavType();
    },
    methods: {
        getNavType() {
            this.navselected = this.$store.state.adminleftnavnum;
            //store.state.adminleftnavnum里值变化的时候，设置navselected
            if (this.navselected === '' || this.navselected === null || this.navselected === undefined) {
                this.navselected = 'home';
            }
        },
        changeData(name) {
            this.$router.push({path: '/admin/' + name});
            this.$store.state.adminleftnavnum = name; //设置左侧导航2-2 active
        },
        // 退出登录
        logout() {
            window.sessionStorage.clear();
            this.$router.push({path: '/login'});
        },
        handleSelect(key) {
            this.$store.state.adminleftnavnum = key; //设置左侧导航2-2 active
        },
    },
    watch: {
        // 监测store.state
        '$store.state.adminleftnavnum': 'getNavType'
    }
}
</script>

<style scoped lang="scss">
    @import "@/assets/styles/admin.scss";
</style>
